<template>
  <b-card>
    <!-- Header: Personal Info -->
    <div class="d-flex text-primary">
      <feather-icon
        icon="SearchIcon"
        size="19"
      />
      <h4 class="mb-0 ml-50 text-primary">
        Busqueda de Persona
      </h4>
    </div>

    <!-- Form: Persona-->
    <validation-observer ref="simpleRules">
      <b-form
        class="mt-1"
        @submit.prevent="validateForm"
      >
        <b-row>

          <!-- Nombre -->
          <b-col
            md="3"
            sm="6"
            xs="12"
          >
            <b-form-group
              label="Nombre"
              label-for="nombre"
            >
              <validation-provider
                #default="{ errors }"
                name="nombre"
                rules="alpha_spaces|min:3|max:255"
              >
                <b-form-input
                  id="nombre"
                  v-model="persona.nombre"
                  :state="errors.length > 0 ? false:null"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- segundo Nombre -->
          <b-col
            md="3"
            sm="6"
            xs="12"
          >
            <b-form-group
              label="Segundo nombre"
              label-for="segundoNombre"
            >
              <validation-provider
                #default="{ errors }"
                name="segundoNombre"
                rules="alpha_spaces|min:3|max:255"
              >
                <b-form-input
                  id="segundoNombre"
                  v-model="persona.segundoNombre"
                  :state="errors.length > 0 ? false:null"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Apellido paterno -->
          <b-col
            md="3"
            sm="6"
            xs="12"
          >
            <b-form-group
              label="Primer Apellido"
              label-for="apellidoPaterno"
            >
              <validation-provider
                #default="{ errors }"
                name="apellidoPaterno"
                rules="alpha_spaces|min:2|max:255"
              >
                <b-form-input
                  id="apellidoPaterno"
                  v-model="persona.apellidoPaterno"
                  :state="errors.length > 0 ? false:null"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Apellido materno  -->
          <b-col
            md="3"
            sm="6"
            xs="12"
          >
            <b-form-group
              label="Segundo Apellido"
              label-for="apellidoMaterno"
            >
              <validation-provider
                #default="{ errors }"
                name="apellidoMaterno"
                rules="alpha_spaces|min:2|max:255"
              >
                <b-form-input
                  id="apellidoMaterno"
                  v-model="persona.apellidoMaterno"
                  :state="errors.length > 0 ? false:null"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            md="6"
            xs="12"
          >
            <b-form-group
              label="CURP"
              label-for="curp"
            >
              <validation-provider
                #default="{ errors }"
                name="curp"
                rules="min:3|max:18"
              >
                <b-form-input
                  id="curp"
                  v-model="persona.curp"
                  :state="errors.length > 0 ? false:null"
                  placeholder="CURP"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xs="12"
          >
            <b-form-group
              label="Correo electrónico principal o alterno"
              label-for="email"
            >
              <validation-provider
                #default="{ errors }"
                name="Correo electrónico principal o alterno"
                rules="min:3|max:255"
              >
                <b-input-group
                  class="input-group-merge"
                >
                  <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon" />
                  </b-input-group-prepend>
                  <b-form-input
                    id="email"
                    v-model="persona.email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Correo electrónico"
                    autocomplete="off"
                  />
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>

            <b-button
              variant="secondary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              type="submit"
            >
              Buscar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <tablabucador
      :busqueda="persona"
      :buscar="buscarE"
      @reiniciarBusqueda="buscarE=$event"
    />
  </b-card>
</template>

<script>
import {
  BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BInputGroupPrepend, BInputGroup, BCard,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { ref } from '@vue/composition-api'
import tablabucador from './tabla-buscador.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BForm,
    BFormInput,
    BCard,
    BInputGroupPrepend,
    BInputGroup,
    ValidationProvider,
    ValidationObserver,
    tablabucador,
  },
  setup() {
    const persona = ref({})
    const buscarE = ref(false)
    const simpleRules = ref(null)

    const validateForm = async () => {
      const success = await simpleRules.value.validate()
      if (!success) return
      buscarE.value = true
    }
    return {
      buscarE,
      persona,
      validateForm,
      simpleRules,
      required,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
